import { useEffect, useState } from "react";
import { Crown, Heart } from "lucide-react";
import { api, fmtDate, money } from "../lib/api";
import { TIER_META, PLAN_LABEL } from "../lib/tiers";

export default function WinnersPage() {
  const [items, setItems] = useState([]);
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/winners").then((r) => setItems(r.data));
    api.get("/public/stats").then((r) => setStats(r.data));
  }, []);
  const all = stats ? Object.values(stats) : [];
  const sum = (k) => all.reduce((a, s) => a + s[k], 0);
  return (
    <div className="max-w-7xl mx-auto px-5 md:px-10 pt-32 pb-24">
      <p className="eyebrow">Our Voyagers</p>
      <h1 className="font-serif-lux text-4xl sm:text-5xl mt-3">They waited their turn.</h1>
      <div className="mt-10 grid sm:grid-cols-3 gap-4">
        <div className="lux-card p-6"><p className="eyebrow !text-slate-500">Trips taken</p><p data-testid="impact-trips" className="font-mono-lux text-3xl mt-3">{sum("trips_awarded")}</p></div>
        <div className="lux-card p-6"><p className="eyebrow !text-slate-500">Trips donated</p><p data-testid="impact-donated-trips" className="font-mono-lux text-3xl mt-3">{sum("trips_donated")}</p></div>
        <div className="lux-card p-6"><p className="eyebrow !text-slate-500">Given to scholarships</p><p data-testid="impact-charity-total" className="font-mono-lux text-3xl mt-3 text-[#38BDF8]">{money(all[0]?.charity_total)}</p></div>
      </div>
      {items.some((w) => w.is_demo) && <p data-testid="winners-demo-label" className="mt-10 text-xs text-amber-200/80">Sample past voyagers for preview — aliases and trips are demo data, not real members.</p>}
      <div className="mt-4 grid md:grid-cols-2 gap-6" data-testid="winners-list">
        {items.map((w) => (
          <div key={w.id} data-testid={`winner-card-${w.id}`} className="lux-card overflow-hidden flex">
            {w.vacation_image && <img src={w.vacation_image} alt={w.vacation_title} className="w-32 md:w-44 object-cover" />}
            <div className="p-6">
              <div className="flex items-center gap-2">
                {w.status === "donated" ? <Heart className="w-5 h-5 text-rose-300" /> : <Crown className="w-5 h-5 text-[#38BDF8]" />}
                <span className="text-[10px] font-mono-lux uppercase tracking-wider text-slate-400">{TIER_META[w.tier]?.short} · {PLAN_LABEL[w.plan]}</span>
                {w.is_demo && <span data-testid={`winner-demo-${w.id}`} className="text-[10px] font-mono-lux uppercase px-2 py-0.5 rounded-full bg-amber-300/10 text-amber-200">Demo</span>}
              </div>
              <h3 className="font-serif-lux text-2xl mt-3">{w.user_alias || "A member"} {w.status === "donated" ? "gave their trip away" : w.status === "bought" ? "bought it now" : "took off"}</h3>
              <p className="text-sm text-slate-300 mt-1">{w.vacation_title} · {w.vacation_location}</p>
              {w.charity_name && <p className="text-sm text-slate-400 mt-2">{money(w.charity_amount)} → {w.charity_name}</p>}
              <p className="font-mono-lux text-xs text-slate-500 mt-3">Won {fmtDate(w.decided_at)}{w.travel_date ? ` · Trip date ${w.travel_date}` : ""}</p>
            </div>
          </div>
        ))}
      </div>
      {items.length === 0 && (
        <div className="mt-10 lux-card p-10 text-slate-400" data-testid="winners-empty">
          No trips completed yet. When a line's pool reaches its goal, its #001 gets the offer.
        </div>
      )}
    </div>
  );
}
